import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const MovingEditingHaug = HelpVideo(
    'MovingEditing',
    'Editor / Features',
    'Moving & Editing',
    10010,
    'https://s.ludi.co/app/haug/10010-moving-editing.mp4'
);


